import { render, staticRenderFns } from "./PinPreview.vue?vue&type=template&id=183c1a00&scoped=true&"
import script from "./PinPreview.vue?vue&type=script&lang=js&"
export * from "./PinPreview.vue?vue&type=script&lang=js&"
import style0 from "./PinPreview.vue?vue&type=style&index=0&id=183c1a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183c1a00",
  null
  
)

export default component.exports